import { gql } from "@apollo/client";


export const VALIDATE_PACIENTE_PE = gql`
query validatePacientePE(
    $idPaciente: Int!
 ){
    validatePacientePE(
        idPaciente: $idPaciente,
    )
}
`;